export const EN = 'en';
export const DE = 'de';
export const ES = 'es';
export const PT = 'pt';
export const FR = 'fr';
export const JA = 'ja';